// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"c30848ef","239":"b68a3cf7","365":"b0d5bf1a","453":"4c31448b","455":"8df2a6eb"}[chunkId] + ".chunk.js";
};